import * as Api from '../api/api';
import * as _ from 'lodash';
import { CarrierOfferState } from '../store/Selection';

export const getAllDeparts = (carrierOffer: Api.CarrierOfferModel): Array<Api.DepartModel> => {
    return (carrierOffer.chargeSet
        && carrierOffer.chargeSet.departs
        && carrierOffer.chargeSet.departs.length !== 0
        ? carrierOffer.chargeSet.departs
        : carrierOffer.routeConfigs.map(x => x.departs).reduce((a, b) => a.concat(b), []));
}

export const getSelectedDepart = (carrierOffer: Api.CarrierOfferModel, carrierOfferState: CarrierOfferState): Api.DepartModel => {
    let departs = carrierOffer.chargeSet
        && carrierOffer.chargeSet.departs
        && carrierOffer.chargeSet.departs.length !== 0
        ? carrierOffer.chargeSet.departs
        : getRouteConfig(carrierOffer, carrierOfferState)?.departs || [];
    return _.sortBy(departs, x => !(carrierOfferState
        && carrierOfferState.selectedDepartId
        && carrierOfferState.selectedDepartId === x.departId))[0];
}

export const getRouteConfig = (carrierOffer: Api.CarrierOfferModel
    , carrierOfferState: CarrierOfferState): Api.RouteConfigModel => {
    return _.sortBy(carrierOffer.routeConfigs,
        x => (carrierOfferState && x.routeServiceId === carrierOfferState.selectedServiceId
            ? 0
            : (carrierOffer.chargeSet && carrierOffer.chargeSet.routeServiceId && carrierOffer.chargeSet.routeServiceId === x.routeServiceId
                ? 1
                : x.transitTime + 2)))[0];
}

export const getBestRouteConfig = (carrierOffer: Api.CarrierOfferModel
    , carrierOfferState: CarrierOfferState): Api.RouteConfigModel => {
    return _.sortBy(carrierOffer.routeConfigs,
        x => (carrierOffer.chargeSet && carrierOffer.chargeSet.routeServiceId &&   ( carrierOffer.chargeSet.routeServiceId === x.routeServiceId  || x.routeServiceId == null  ) &&

            (x.transShipments && carrierOffer.chargeSet.transShipments &&  x.transShipments.map(x => x.port?.code).join("-") == carrierOffer.chargeSet.transShipments.map(x => x.port?.code).join("-"))
            ? 1
            : x.transitTime + 2))[0];
}


export const getBestRouteConfigWithTranshipment = (carrierOffer: Api.CarrierOfferModel  //todo to think if we can replace above for this because it depends many time of Include
    , carrierOfferState: CarrierOfferState): Api.RouteConfigModel => {

    
    var ret =  _.sortBy(carrierOffer.routeConfigs,
        x => (carrierOffer.chargeSet && carrierOffer.chargeSet.routeServiceId &&   ( carrierOffer.chargeSet.routeServiceId === x.routeServiceId  || x.routeServiceId == null  ) &&

            (x.transShipments && carrierOffer.chargeSet.transShipments &&  x.transShipments.map(x => x.port?.code).join("-") == carrierOffer.chargeSet.transShipments.map(x => x.port?.code).join("-"))
            ? 1
            : x.transitTime + 2))[0];
    return ret;
}

